import styled from "styled-components"

export const CloseButton = ({
  onClick,
  width = 16,
  height = 16,
  color,
  ariaLabel = "Close",
  customCss
}) =>

  <Button onClick={onClick} aria-label={ariaLabel} $css={customCss}>
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.05155 15.648C1.58223 16.1173 0.82131 16.1173 0.35199 15.648C-0.11733 15.1787 -0.11733 14.4178 0.35199 13.9485L5.29897 9.00147C5.85207 8.44837 5.85207 7.55162 5.29897 6.99853L0.35199 2.05155C-0.11733 1.58223 -0.11733 0.82131 0.35199 0.35199C0.82131 -0.11733 1.58223 -0.11733 2.05155 0.35199L6.99852 5.29897C7.55162 5.85207 8.44837 5.85207 9.00147 5.29897L13.9485 0.35199C14.4178 -0.11733 15.1787 -0.11733 15.648 0.35199C16.1173 0.82131 16.1173 1.58223 15.648 2.05155L10.701 6.99852C10.1479 7.55162 10.1479 8.44837 10.701 9.00147L15.648 13.9485C16.1173 14.4178 16.1173 15.1787 15.648 15.648C15.1787 16.1173 14.4178 16.1173 13.9485 15.648L9.00147 10.701C8.44837 10.1479 7.55162 10.1479 6.99853 10.701L2.05155 15.648Z"
        fill={color}
      />
    </svg>
  </Button>

const Button = styled.button`
    background-color: transparent;
    border: none;
    position: absolute;
    box-sizing: border-box;
    right: 8px;
    top: 7px;
    z-index: 2;
    width: 32px;
    height: 32px;

    ${({ $css }) => $css && $css}
`
